import React, { useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCode } from "@fortawesome/free-solid-svg-icons"
import { faJsSquare } from "@fortawesome/free-brands-svg-icons"
import { faCss3Alt } from "@fortawesome/free-brands-svg-icons"

function servicesHeader() {
  useEffect(() => {
    const isBrowser = typeof window !== "undefined"
    const AOS = isBrowser ? require("aos") : undefined

    AOS.init()
  })
  return (
    <div>
      <section className="ftco-section">
        <div className="container mt-5">
          <div className="row justify-content-center mb-5 pb-5">
            <div
              className="col-md-7 text-center heading-section"
              data-aos="fade-up"
            >
              <span>What i do</span>
              <h2>My services</h2>
            </div>
          </div>
          <div className="row">
            <div
              className="col-md-4 d-flex align-self-stretch ftco-animate"
              data-aos="fade-up"
            >
              <div className="media block-6 services p-3 py-4 d-block text-center">
                <div className="icon mb-3">
                  <FontAwesomeIcon
                    className="fontAwesomeIcon"
                    icon={faJsSquare}
                  />
                </div>
                <div className="media-body">
                  <h3 className="heading">Next</h3>
                  <h3 className="heading">Gatsby</h3>
                </div>
              </div>
            </div>
            <div
              className="col-md-4 d-flex align-self-stretch ftco-animate"
              data-aos="fade-up"
            >
              <div className="media block-6 services p-3 py-4 d-block text-center">
                <div className="icon mb-3">
                  <FontAwesomeIcon
                    className="fontAwesomeIcon"
                    icon={faCss3Alt}
                  />
                </div>
                <div className="media-body">
                  <h3 className="heading">Tailwind</h3>
                  <h3 className="heading">Bootstrap</h3>
                </div>
              </div>
            </div>
            <div
              className="col-md-4 d-flex align-self-stretch ftco-animate"
              data-aos="fade-up"
            >
              <div className="media block-6 services p-3 py-4 d-block text-center">
                <div className="icon mb-3">
                  <FontAwesomeIcon className="fontAwesomeIcon" icon={faCode} />
                </div>
                <div className="media-body">
                  <h3 className="heading">Markup</h3>
                  <h3 className="heading">Markdown</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default servicesHeader
